import React from "react";
import styles from "./privacy-policy.module.scss";
import { SeoComponent } from "../../components/seo/Seo.component";

export const PrivacyPolicy: React.FC = () => {
  return (
    <div className={styles["privacy-policy"]}>
      <SeoComponent
        title="Privacy Policy | Volumetric"
        description="Read our Privacy Policy to understand how Volumetric Labs collects, uses, and safeguards your information."
      />
      <h1 className={styles["section-title"]}>Privacy Policy</h1>

      <div className={styles["content"]}>
        <p>Last updated: 28-11-2025</p>

        <h2>1. Introduction</h2>
        <p>
          Volumetric Labs ("we", "our", or "us") is committed to protecting your
          privacy. This Privacy Policy explains how we collect, use, disclose,
          and safeguard your information when you visit our website. Please read
          this privacy policy carefully. If you do not agree with the terms of
          this privacy policy, please do not access the site.
        </p>

        <h2>2. Collection of Your Information</h2>
        <p>
          We may collect information about you in a variety of ways. The
          information we may collect on the Site includes:
        </p>
        <ul>
          <li>
            <strong>Personal Data:</strong> Personally identifiable information,
            such as your name, shipping address, email address, and telephone
            number, and demographic information, such as your age, gender,
            hometown, and interests, that you voluntarily give to us when you
            register with the Site or when you choose to participate in various
            activities related to the Site.
          </li>
          <li>
            <strong>Derivative Data:</strong> Information our servers
            automatically collect when you access the Site, such as your IP
            address, your browser type, your operating system, your access
            times, and the pages you have viewed directly before and after
            accessing the Site.
          </li>
        </ul>

        <h2>3. Use of Your Information</h2>
        <p>
          Having accurate information about you permits us to provide you with a
          smooth, efficient, and customized experience. Specifically, we may use
          information collected about you via the Site to:
        </p>
        <ul>
          <li>Create and manage your account.</li>
          <li>
            Compile anonymous statistical data and analysis for use internally
            or with third parties.
          </li>
          <li>Email you regarding your account or order.</li>
          <li>Enable user-to-user communications.</li>
          <li>
            Fulfill and manage purchases, orders, payments, and other
            transactions related to the Site.
          </li>
          <li>
            Generate a personal profile about you to make future visits to the
            Site more personalized.
          </li>
          <li>Increase the efficiency and operation of the Site.</li>
          <li>
            Monitor and analyze usage and trends to improve your experience with
            the Site.
          </li>
          <li>Notify you of updates to the Site.</li>
          <li>Offer new products, services, and/or recommendations to you.</li>
        </ul>

        <h2>4. Disclosure of Your Information</h2>
        <p>
          We may share information we have collected about you in certain
          situations. Your information may be disclosed as follows:
        </p>
        <ul>
          <li>
            <strong>By Law or to Protect Rights:</strong> If we believe the
            release of information about you is necessary to respond to legal
            process, to investigate or remedy potential violations of our
            policies, or to protect the rights, property, and safety of others,
            we may share your information as permitted or required by any
            applicable law, rule, or regulation.
          </li>
          <li>
            <strong>Third-Party Service Providers:</strong> We may share your
            information with third parties that perform services for us or on
            our behalf, including payment processing, data analysis, email
            delivery, hosting services, customer service, and marketing
            assistance.
          </li>
        </ul>

        <h2>5. GDPR Rights</h2>
        <p>
          If you are a resident of the European Economic Area (EEA), you have
          certain data protection rights. Volumetric Labs aims to take
          reasonable steps to allow you to correct, amend, delete, or limit the
          use of your Personal Data.
        </p>
        <p>
          If you wish to be informed what Personal Data we hold about you and if
          you want it to be removed from our systems, please contact us.
        </p>
        <p>
          In certain circumstances, you have the following data protection
          rights:
        </p>
        <ul>
          <li>
            The right to access, update or to delete the information we have on
            you.
          </li>
          <li>The right of rectification.</li>
          <li>The right to object.</li>
          <li>The right of restriction.</li>
          <li>The right to data portability.</li>
          <li>The right to withdraw consent.</li>
        </ul>

        <h2>6. Contact Us</h2>
        <p>
          If you have questions or comments about this Privacy Policy, please
          contact us at:
        </p>
        <p>
          <a href="mailto:contact@volumetric.dev">contact@volumetric.dev</a>
        </p>
      </div>
    </div>
  );
};
